import { FC } from 'react'
import { Link } from 'react-router-dom'
import graph from '../../Images/Graph.svg'
import Home from '../../Images/Home.svg'
import Logout from '../../Images/Logout.svg'
import Pessoas from '../../Images/Pessoas.svg'
import Pointer from '../../Images/pointer.svg'
import { AreaSidebar } from './styled'

export const SideBar: FC = () => {
  const permissoes = localStorage.getItem('permissoes')
  let permissao = []
  if (permissoes) {
    permissao = JSON.parse(permissoes)
  } else {
    permissao = [
      {
        perModulo: 'ACECAD',
        perAcesso: 1
      },
      {
        perModulo: 'ACELOC',
        perAcesso: 1
      },
      {
        perModulo: 'ACEPES',
        perAcesso: 1
      },
      {
        perModulo: 'ACEAUD',
        perAcesso: 1
      },
      {
        perModulo: 'ACETXT',
        perAcesso: 1
      },
      {
        perModulo: 'ACEUNI',
        perAcesso: 1
      },
      {
        perModulo: 'ACEGPU',
        perAcesso: 1
      },
      {
        perModulo: 'ACEFUN',
        perAcesso: 1
      },
      {
        perModulo: 'ACEREL',
        perAcesso: 1
      },
      {
        perModulo: 'ACETPD',
        perAcesso: 1
      },
      {
        perModulo: 'ACEDOC',
        perAcesso: 1
      }
    ]
  }
  let ACECAD = permissao.find((element: any) => {
    return element.perModulo === 'ACECAD'
  })
  let ACELOC = permissao.find((element: any) => {
    return element.perModulo === 'ACELOC'
  })
  let ACEPES = permissao.find((element: any) => {
    return element.perModulo === 'ACEPES'
  })
  let ACEAUD = permissao.find((element: any) => {
    return element.perModulo === 'ACEAUD'
  })
  let ACETXT = permissao.find((element: any) => {
    return element.perModulo === 'ACETXT'
  })
  let ACEUNI = permissao.find((element: any) => {
    return element.perModulo === 'ACEUNI'
  })
  let ACEGPU = permissao.find((element: any) => {
    return element.perModulo === 'ACEGPU'
  })
  let ACEFUN = permissao.find((element: any) => {
    return element.perModulo === 'ACEFUN'
  })
  let ACEREL = permissao.find((element: any) => {
    return element.perModulo === 'ACEREL'
  })
  let ACETPD = permissao.find((element: any) => {
    return element.perModulo === 'ACETPD'
  })
  let ACEDOC = permissao.find((element: any) => {
    return element.perModulo === 'ACEDOC'
  })
  return (
    <AreaSidebar>
      {!!ACEREL.perAcesso ? (
        <div>
          <Link to="/Home">
            <div data-toggle="tooltip" data-placement="right" title="Home">
              <img src={Home} width="100%" height="100%" alt="relatorio" />
            </div>
          </Link>
        </div>
      ) : (
        <li></li>
      )}
      {!!ACECAD.perAcesso ? (
        <div>
          <Link to="/FormularioCadastro">
            <div data-toggle="tooltip" data-placement="right" title="Cadastro">
              <img src={Pointer} width="100%" height="100%" alt="Cadastro" />
            </div>
          </Link>
        </div>
      ) : !!ACEDOC.perAcesso ? (
        <div>
          <Link to="/Documentos">
            <div data-toggle="tooltip" data-placement="right" title="Cadastro">
              <img src={Pointer} width="100%" height="100%" alt="Cadastro" />
            </div>
          </Link>
        </div>
      ) : (
        <li></li>
      )}
      {!!ACEPES.perAcesso ? (
        <div>
          <Link to="/Pessoas">
            <div
              data-toggle="tooltip"
              data-placement="right"
              title="Gerentes / Operadores"
            >
              <img src={Pessoas} width="100%" height="100%" alt="Pessoas" />
            </div>
          </Link>
        </div>
      ) : (
        <li></li>
      )}
      {!!ACEREL.perAcesso ? (
        <div>
          <Link to="/Relatorio">
            <div
              data-toggle="tooltip"
              data-placement="right"
              title="Relatorio / Auditorias"
            >
              <img
                src={graph}
                width="100%"
                height="100%"
                alt="Relatorio / Auditorias"
              />
            </div>
          </Link>
        </div>
      ) : (
        <li></li>
      )}
      <div className="espaçoMenu">
        <Link to="/">
          <div data-toggle="tooltip" data-placement="right" title="Logout">
            <img src={Logout} width="100%" height="100%" alt="desconectar" />
          </div>
        </Link>
      </div>
    </AreaSidebar>
  )
}
